var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0h0V24H0V0H24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    fill: "{props.color}",
    d: "M1.25,9v-2.5C1.25,3.6,3.61,1.25,6.5,1.25h2.5c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75h-2.5c-2.07,0-3.75,1.68-3.75,3.75v2.5c0,.41-.34,.75-.75,.75s-.75-.34-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fill: "{props.color}",
    d: "M21.25,9v-2.5c0-2.07-1.68-3.75-3.75-3.75h-2.5c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75h2.5c2.89,0,5.25,2.35,5.25,5.25v2.5c0,.41-.34,.75-.75,.75s-.75-.34-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    fill: "{props.color}",
    d: "M16,22.75c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75h1.5c2.07,0,3.75-1.68,3.75-3.75v-1.5c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v1.5c0,2.9-2.36,5.25-5.25,5.25h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    fill: "{props.color}",
    d: "M6.5,22.75c-2.89,0-5.25-2.35-5.25-5.25v-2.5c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v2.5c0,2.07,1.68,3.75,3.75,3.75h2.5c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    fill: "evenodd",
    d: "M6.62,11.38c0-2.62,2.13-4.75,4.75-4.75s4.75,2.13,4.75,4.75-2.13,4.75-4.75,4.75-4.75-2.13-4.75-4.75Zm1.5,.01c0,1.79,1.46,3.25,3.25,3.25s3.25-1.46,3.25-3.25-1.46-3.25-3.25-3.25-3.25,1.46-3.25,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    fill: "{props.color}",
    d: "M16.17,17.35c-.06,0-.12-.03-.18-.06-.06-.02-.12-.05-.18-.09l-.15-.12c-.18-.19-.29-.45-.29-.71,0-.13,.03-.26,.08-.38,.05-.12,.12-.23,.21-.33,.37-.37,1.05-.37,1.42,0,.09,.1,.16,.21,.21,.33,.05,.12,.08,.25,.08,.38,0,.26-.11,.52-.29,.71-.19,.18-.45,.29-.71,.29-.07,0-.13,0-.2-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    fill: "none",
    d: "M24,0V24H0V0H24Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-search.7035bf86f2459037978dcc6974abf376.svg";
export { ForwardRef as ReactComponent };